export const reset_password = {
  field: {
    email: 'Адрес электронной почты',
    password: 'Пароль',
    confirm_password: 'Подтвердите пароль',
    code: 'Проверочный код из письма'
  },
  button: { send_code: 'Отправить код сброса пароля', reset: 'Сбросить пароль' },
  link: {
    to_auth_page: 'Вернуться на страницу авторизации',
    success_change_link_to_auth_page: 'авторизоваться',
    send_repeated: 'Отправить код повторно'
  },
  error: {
    wrong_email: 'Неверный e-mail',
    wait_attempts_time_interval: 'Повторите попытку через 30 секунд',
    wrong_password: 'Пароль не соответствует требованиям',
    email_code_not_found_or_has_expired: 'Неверный код',
    not_valid_password: 'Ваш пароль не валидный',
    code_size: 'Код должен быть 6 символов',
    invalid_format: "Поле Новый пароль имеет ошибочный формат"
  },
  password_email_not_received: 'Не пришло письмо с кодом?',
  success_change_password: 'Пароль успешно изменен, теперь вы можете',
  success_send_code:
    'На вашу почту {email} отправлено письмо с кодом, введите его в поле ниже, чтобы продолжить',
  generate_password: 'Сгенерировать пароль',
  password_requirements: 'Требования к паролю',
  six_symbols: '6 символов',
  one_number: '1 цифра',
  one_uppercase_letter: '1 заглавная буква',
  one_lowercase_letter: '1 прописная буква',
  one_special_character: '1 специальный символ (!@#;%^&* и тд)',
  password_spaces: 'Пароль без пробелов',
  matched_passwords: 'Пароли совпадают',
  change_by: {
    email: 'Изменить через email',
    password: 'Изменить через текущий пароль'
  },
  day_block: "Закончился лимит ежедневных попыток, воспользуйтесь последним присланным кодом или запросите новый завтра",
  code_exist: 'Воспользуйтесь последним присланным кодом или запросите новый',
  send_email_to_confirm: 'На вашу почту {email} будет отправлено письмо с кодом.',
  send: 'Отправить',
};
